module.exports = __webpack_public_path__ + "static/media/image-card-7.c2e12a0c.png";